import { render, staticRenderFns } from "./AdminNavigation.vue?vue&type=template&id=b6cf7672&scoped=true"
var script = {}
import style0 from "./AdminNavigation.vue?vue&type=style&index=0&id=b6cf7672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6cf7672",
  null
  
)

export default component.exports